export default "__VITE_ASSET__1vkxRYtg__"